import styled from 'styled-components';

import { ColorName, FontFamily, FontWeightName, TextAlign, TextTransform } from 'types';

import { FontScale, getFontScale } from 'themes/mixins/getFontScale';

export type TextProps = {
  scale?: FontScale;
  color?: ColorName;
  fontWeight?: FontWeightName;
  textTransform?: TextTransform;
  textAlign?: TextAlign;
  fontFamily?: FontFamily;
  isWrapped?: boolean;
};

const Text = styled.p<TextProps>`
  ${({ scale }) => scale && getFontScale(scale)};

  margin: 0;

  color: ${({ theme, color }) => (color ? theme.colors[color] : theme.colors.grayDark)};

  white-space: ${({ isWrapped }) => (isWrapped ? 'normal' : 'nowrap')};

  font-family: ${({ fontFamily }) => `${fontFamily}, sans-serif`};
  font-weight: ${({ theme, fontWeight }) =>
    fontWeight ? theme.fontWeights[fontWeight] : theme.fontWeights.normal};

  text-transform: ${({ theme, textTransform }) =>
    textTransform && textTransform !== 'isFirstLetterUppercase'
      ? theme.textTransforms[textTransform]
      : theme.textTransforms.none};
  text-align: ${({ theme, textAlign }) =>
    textAlign ? theme.textAligns[textAlign] : theme.textAligns.left};
`;

export { Text };
